export default {
      id: "pay_dolyami-usage",
      viewBox: "0 0 72 21",
      url: __webpack_public_path__ + "sprite.svg#pay_dolyami",
      toString: function () {
        return this.url;
      }
    }